import { render, staticRenderFns } from "./Desempenho.vue?vue&type=template&id=d44b1d70&scoped=true"
import script from "./Desempenho.vue?vue&type=script&lang=js"
export * from "./Desempenho.vue?vue&type=script&lang=js"
import style0 from "./Desempenho.vue?vue&type=style&index=0&id=d44b1d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44b1d70",
  null
  
)

export default component.exports